import { useCurrentUser } from "web/hooks/data"

import ViewerLink from "./ViewerLink"

export default function CompanyViewer({ value, showLinkIcon, truncateValue }) {
  const currentUser = useCurrentUser()
  if (!currentUser || currentUser.is_guest) return <span>{value.label}</span>

  return (
    <ViewerLink
      href={`/companies/all/view/${value.value}`}
      label={value.label}
      showLinkIcon={showLinkIcon}
      truncateValue={truncateValue}
    />
  )
}

CompanyViewer.isViewerFor = (x) => x.kind === "Company"
